const prod = {
    API_URL: 'https://admin.horecaidea.pl/api',
    WS_URL: 'https://admin.horecaidea.pl/ws',
};
const dev = {
    API_URL: 'http://localhost:8081',
    WS_URL: 'http://localhost:8081'
};

export const config = process.env.NODE_ENV === 'development' ? dev : prod;